/* IV Supply Clinic: add to cart from custom sections, then open the theme's cart drawer. */
if (!window.__ivscAddToCart) {
window.__ivscAddToCart = true;
document.addEventListener('submit', async function (event) {
var form = event.target.closest('form.ivsc-ajax-add');
if (!form) return;
var drawer = document.querySelector('cart-drawer');
if (!drawer || typeof drawer.renderContents !== 'function' || !window.routes) return;
event.preventDefault();
var button = form.querySelector('[type="submit"]');
if (button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); }
var data = new FormData(form);
data.append('sections', 'cart-drawer,cart-icon-bubble');
data.append('sections_url', window.location.pathname);
try {
var res = await fetch(window.routes.cart_add_url, {
method: 'POST',
headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
body: data
});
var json = await res.json();
if (json.status) { form.submit(); return; }
if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
drawer.renderContents(json);
} catch (e) {
form.submit();
} finally {
if (button) { button.disabled = false; button.removeAttribute('aria-busy'); }
}
});
}
/* IV Supply Clinic: product photo framing. Trims the white margin around each product photo and
   scales the product to the same size in every frame, so bags, kits and boxes line up across the site. */
(function () {
if (window.__ivscFrame) return;
window.__ivscFrame = true;
var SEL = '.ivsc-pcard__img img, .ivsc-cat__img img, .product-media-container .media img, .thumbnail img';
var PAD = 0.08;
var cache = {};
function key(src) { return (src || '').split('?')[0]; }
function bbox(img) {
  var k = key(img.currentSrc || img.src);
  if (cache[k]) return cache[k];
  var W = img.naturalWidth, H = img.naturalHeight;
  if (!W || !H) return null;
  var cw = 160, ch = Math.max(1, Math.round(160 * H / W));
  var c = document.createElement('canvas'); c.width = cw; c.height = ch;
  var x = c.getContext('2d', { willReadFrequently: true });
  try { x.drawImage(img, 0, 0, cw, ch); var d = x.getImageData(0, 0, cw, ch).data; } catch (e) { return null; }
  var cols = new Array(cw).fill(0), rows = new Array(ch).fill(0);
  for (var y = 0; y < ch; y++) for (var i = 0; i < cw; i++) {
    var p = (y * cw + i) * 4, r = d[p], g = d[p + 1], b = d[p + 2], a = d[p + 3];
    var mn = Math.min(r, g, b), mx = Math.max(r, g, b);
    if (a > 16 && (mn < 232 || mx - mn > 20)) { cols[i]++; rows[y]++; }
  }
  function first(arr) { for (var j = 0; j < arr.length; j++) if (arr[j] > 1) return j; return -1; }
  function last(arr) { for (var j = arr.length - 1; j >= 0; j--) if (arr[j] > 1) return j; return -1; }
  var x0 = first(cols), x1 = last(cols), y0 = first(rows), y1 = last(rows);
  if (x0 < 0 || y0 < 0) return null;
  var r = { x0: x0 / cw, x1: (x1 + 1) / cw, y0: y0 / ch, y1: (y1 + 1) / ch, W: W, H: H };
  cache[k] = r;
  return r;
}
function fit(img) {
  var frame = img.parentElement;
  if (!frame || !img.complete || !img.naturalWidth) return;
  var fw = frame.clientWidth, fh = frame.clientHeight;
  if (!fw || !fh) return;
  var b = bbox(img);
  if (!b) return;
  var sw = (b.x1 - b.x0) * b.W, sh = (b.y1 - b.y0) * b.H;
  var s = Math.min(fw * (1 - 2 * PAD) / sw, fh * (1 - 2 * PAD) / sh);
  var w = b.W * s, h = b.H * s;
  var left = fw / 2 - (b.x0 + b.x1) / 2 * w, top = fh / 2 - (b.y0 + b.y1) / 2 * h;
  if (getComputedStyle(frame).position === 'static') frame.style.position = 'relative';
  frame.style.overflow = 'hidden';
  var st = img.style;
  st.setProperty('position', 'absolute', 'important');
  st.setProperty('max-width', 'none', 'important');
  st.setProperty('max-height', 'none', 'important');
  st.setProperty('padding', '0', 'important');
  st.setProperty('object-fit', 'fill', 'important');
  st.setProperty('width', (w / fw * 100) + '%', 'important');
  st.setProperty('height', (h / fh * 100) + '%', 'important');
  st.setProperty('left', (left / fw * 100) + '%', 'important');
  st.setProperty('top', (top / fh * 100) + '%', 'important');
  img.setAttribute('data-ivsc-fit', key(img.currentSrc || img.src));
}
var ro = window.ResizeObserver ? new ResizeObserver(function (entries) {
  entries.forEach(function (e) { var img = e.target.__ivscImg; if (img) fit(img); });
}) : null;
function watch(img) {
  var frame = img.parentElement;
  if (!frame || frame.__ivscImg === img) return;
  frame.__ivscImg = img;
  if (ro) ro.observe(frame);
}
function run() {
  document.querySelectorAll(SEL).forEach(function (img) {
    watch(img);
    if (img.naturalWidth && img.getAttribute('data-ivsc-fit') !== key(img.currentSrc || img.src)) fit(img);
  });
}
var queued = false;
function queue() { if (queued) return; queued = true; requestAnimationFrame(function () { queued = false; run(); }); }
function start() {
  run();
  document.addEventListener('load', function (e) {
    var t = e.target;
    if (t && t.tagName === 'IMG' && t.matches(SEL)) { watch(t); fit(t); }
  }, true);
  new MutationObserver(queue).observe(document.body, { childList: true, subtree: true });
  window.addEventListener('load', queue);
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
